var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boxshell"},[_c('div',{staticClass:"box"},[_c('div',{ref:"qrCodeUrl",staticStyle:{"display":"none"},attrs:{"id":"codeDiv"}}),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scanCodeBox"},[_c('div',{staticClass:"qrcode",attrs:{"id":"qrcode"}})])
}]

export { render, staticRenderFns }